import React from 'react';

export default class PasswordInput extends React.Component {
  state = {
    showPass: false,
  };

  toggleShowPass = () => {
    this.setState((prev) => ({ showPass: !prev.showPass }));
  };

  handleChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    const { value, id, className = '', placeholder } = this.props;
    const inputType = this.state.showPass ? 'text' : 'password';

    return (
      <div className="input-group">
        <input 
          type={inputType}
          className={`form-control ${className}`}
          id={id}
          value={value}
          onChange={this.handleChange}
          placeholder={placeholder}
        />
        <div className="input-group-append">
          <button 
            className="btn btn-outline-secondary" 
            type="button" 
            onClick={this.toggleShowPass}
          >
            <i className={this.state.showPass ? 'bi bi-eye-slash' : 'bi bi-eye'}></i>
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/password-input.js